import React from "react"
import styled from 'styled-components'
import SaleTitleImage from "../../images/sale/sale-title.png"
import OfferImage from "../../images/sale/offer.png"
import WhiteButton from "../button/WhiteButton"
import PhoneIcon from "../Icons/PhoneIcon"


const SaleLocation = styled.div`
    position: relative;    
`
const SaleContainer = styled.div`   
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;    
`

const SaleRow = styled.div`
    display:flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin:0 -10px;    
    padding:30px 0 20px 0;
    flex-wrap: wrap;
    @media (min-width: 576px) {    
        flex-wrap: nowrap;
    }
    @media (min-width: 992px) {    
        margin:0 -15px;        
        max-width:950px;        
    }
    @media (min-width: 1200px) {
        max-width:1160px;
        padding:40px 0 30px 0;
    }
    @media (min-width: 1400px) {
        max-width:1200px;
        padding:60px 0 40px 0;
    }
    @media (min-width: 1600px) {
        margin:0 -30px;
        max-width:100%;
        padding:80px 0 60px 0;
    }
`
const SaleLeftColumn = styled.div`
    display:flex;
    align-items: center;
    justify-content: center;
    position:relative;
    width:100%;
    padding:0 10px;
    flex:0 0 50%;
    max-width: 50%;
    @media (min-width: 576px) {    
        flex:0 0 33.333333%;
        max-width: 33.333333%;
    }    
    @media (min-width: 992px) {    
        padding:0 15px;        
    }
    @media (min-width: 1600px) {
        padding:0 30px;
    }   
`

const SaleColumn = styled.div`   
    display:flex;
    align-items: center;
    justify-content: center;
    position:relative;
    width:100%;
    padding:0 10px;
    flex:0 0 50%;
    max-width: 50%;    
    @media (min-width: 576px) {    
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }

    @media (min-width: 992px) {    
        padding:0 15px;        
    }
    @media (min-width: 1600px) {
        padding:0 30px;
    }   
`

const SaleRightColumn = styled.div`
    display:flex;
    align-items: center;
    justify-content: center;
    position:relative;
    width:100%;
    padding:0 10px;
    @media (min-width: 576px) {    
        flex:0 0 33.333333%;
        max-width: 33.333333%;
    }
    
    @media (min-width: 992px) {    
        padding:0 15px;        
    }
    @media (min-width: 1600px) {
        padding:0 30px;
    }   
`

//CSS for Desktop
const SaleTitle = styled.div`
    text-align:center;
    img{        
        width:auto;
        margin:0 auto;        
        width:80%;
    }
    @media (min-width: 992px) {  
        img{
            width:80%;
        }      
    }
    @media (min-width: 1200px) {  
        img{
            width:90%;
        }      
    }
    @media (min-width: 1600px) {
        img{
            width:auto;
        }
    }
    
`
const SaleOffter = styled.div`
    text-align:center;
    img{                
        margin:0 auto;       
    }    
`



const ButtonToolbar = styled.div`
    flex-wrap: wrap;
    align-items:center;
    justify-content:center;
    flex-direction: column;
    margin: 0 auto;
    border:1px solid #fff;
    background-color:#03050A;
    margin: 4px;
    display:flex;
    width: 100%;
    @media (min-width: 576px) {
        display: inline-flex;
        width:auto;
    }
    .btn-label{
        display:flex;
        justify-content: center;
        align-items:center;
        color:#fff;
        font-size: 10px;
        line-height: 18px;
        @media (min-width: 768px) {
            font-size: 12px;
            line-height: 20px;
        }        
        @media (min-width: 1200px) {
            font-size: 16px;            
            margin: 6px;
        }
        @media (min-width: 1400px) {
            margin: 10px;
            font-size: 18px;
        }
    }
    a{
        display: flex;
        width: 100%;
    }
    .btn{
        display: flex;
        align-items: center;
        justify-content: center;
        width:100%;
        border:none;
        padding: 8px 10px;
        &:before {
		    background:#7d7c7c;
        }
        > svg{
            + .text{
                margin-left:5px;
                @media (min-width: 576px) {
                    margin-left:10px;
                }
            }
        }
        > .icon{
            + .text{
                margin-left:5px;
                @media (min-width: 576px) {
                    margin-left:10px;
                }
            } 
        }     
    }
`

const SaleBlackFriday = ({ location }) => {
    return (
        <SaleLocation location={location}>
            <SaleContainer>
                <SaleRow>
                    <SaleLeftColumn>
                        <SaleTitle><img src={SaleTitleImage} alt="Premier Metal Structures" /></SaleTitle>
                    </SaleLeftColumn>
                    <SaleColumn>
                        <SaleOffter><img src={OfferImage} alt="Premier Metal Structures" /></SaleOffter>
                    </SaleColumn>
                    <SaleRightColumn>
                        <ButtonToolbar>                            
                            <span className="btn-label">Call Us For More Details</span>
                            <a href='tel:8776005980' aria-label="phone number">
                                <WhiteButton icon={<PhoneIcon />} text="(877) 600-5980" />
                            </a>                                
                        </ButtonToolbar>      
                    </SaleRightColumn>
                </SaleRow>
            </SaleContainer>       
        </SaleLocation>
    )
}
export default SaleBlackFriday